import React from "react";
import Navbar from "../../component/Navbar/Navbar";
import Footer from "../../component/Footer/Footer";
import HeroSection from "./HeroSection";
import StepsSection from "./StepsSection";
import DemoSection from "./DemoSection";
import AppsSection from "./AppsSection";
import TrustedSection from "./TrustedSection";
import PricingSection from "./PricingSection";
import FAQSection from "./FAQSection";
import CTASection from "./CTASection";

const DownloadForWindow = () => {
  return (
    <>
      <div className="bg-white md:p-4 p-3 flex flex-col xl:gap-32 lg:gap-24 gap-20 max-w-screen-2xl mx-auto leading-tight">
        <Navbar />
        <HeroSection />
        <StepsSection />
        {/* <DemoSection /> */}
        <div className="md:mt-16 mt-10">
          <AppsSection />
        </div>
        <div className="md:mt-32 mt-16">
          <TrustedSection />
        </div>
        <PricingSection />
        <FAQSection />
        <CTASection />
      </div>
      <div className="md:mt-20 mt-12">
        <Footer />
      </div>
    </>
  );
};

export default DownloadForWindow;
